export default __webpack_public_path__ + "static/media/icon-mastercard.f32b0b19c0681cdd2967d0a40db5b732.svg";